import { useTranslation } from '@mint-lib/i18n';
import { WarningAltFilled } from '@mint-lib/icons';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type EditProps = {
  handleGenerate: () => void;
  onClose: () => void;
  isOpen: boolean;
};

const Edit = ({ handleGenerate, onClose, isOpen }: EditProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <Dialog open={isOpen} modal>
      <DialogOverlay />
      <DialogRoot size={'s'}>
        <DialogHeader onClose={onClose}>
          <DialogTitle className="flex flex-row items-center gap-2">
            <WarningAltFilled className="fill-error-main" />
            {t('Delete this items?')}
          </DialogTitle>
        </DialogHeader>

        <DialogContent className="flex flex-col">
          <div className="flex flex-col">
            <p
              className={typographyVariants({
                variant: 'bodyLong01',
                color: 'secondary',
              })}
            >
              {t(
                'By clicking cancel the edit mode you will lose your changing. Do you want to exit edit mode?',
              )}
            </p>
            <p
              className={typographyVariants({
                variant: 'bodyLong01',
                color: 'secondary',
              })}
            >
              {t('Are you sure you want to delete the selected items?')}
            </p>
          </div>
        </DialogContent>
        <DialogFooter className="flex flex-row gap-2">
          <Button
            onClick={onClose}
            variant="plain"
            className="p-3"
            size="large"
            aria-label="close-button"
          >
            {t('Cancel')}
          </Button>
          <Button
            onClick={handleGenerate}
            variant="contained"
            color="error"
            size="large"
          >
            {t('Yes, delete')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};
export default Edit;
